import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import CLOSE from '../../assets/imgs/icon/close.svg';
import { useAppDispatch } from '../../reduxstore/hooks';
import Flex from '../Flex';
import IconButton from '../IconButton';
import { hideBannerPrompt } from '../../domains/UI/store/slice';

export const PromptBanner = ({
	$background,
	to,
	text,
	...props
}: BannerProps): JSX.Element => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const dismissPrompt = () => {
		dispatch(hideBannerPrompt());
	};
	return (
		<StyledBanner
			$flexDirection="row"
			$placeContent="center space-between"
			$alignItems="center"
			$height="auto"
			$background={$background}
			to={to}
			{...props}
		>
			<BannerText onClick={() => navigate(`${to}`)}>{text}</BannerText>
			<IconButton url={CLOSE} alt="X" onClick={dismissPrompt} />
		</StyledBanner>
	);
};

const StyledBanner = styled(Flex)<BannerProps>`
	padding: 10px;
	background-color: ${props => props.$background || '#333'};
	z-index: 3;
	position: fixed;
	cursor: pointer;
`;

const BannerText = styled.span`
	color: #000000;
	width: 100%;
	text-align: center;
	padding: 0 8px;
	line-height: 120%;
`;

interface BannerProps {
	$background?: string;
	to?: string;
	text?: string;
}
